import { useCurrencyPaymentsFilters } from './hooks/useCurrencyPaymentsFilters'
import { DateFilter } from './filters/DateFilter'
import { AmountFilter } from './filters/AmountFilter'
import { SelectionSummary } from './filters/SelectionSummary'
import { AdvancedFilters } from './filters/AdvancedFilters'
import { PaymentGatewayDropdown } from './filters/PaymentGatewayDropdown'
import { AreaSalesFilter } from './filters/AreaSalesFilter'
import { Building2 } from 'lucide-react'

export const FiltersRow = () => {
  const {
    filters,
    hasActiveFilters,
    updatePaymentGatewayIds,
    updateDateRange,
    updateAmount,
    updateCodeCurrency,
    updateAreaSalesId,
  } = useCurrencyPaymentsFilters()

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <DateFilter
            dateFrom={filters.dateFrom}
            dateTo={filters.dateTo}
            onDateRangeChange={updateDateRange}
          />

          <AmountFilter
            amountFrom={filters.amountFrom}
            amountTo={filters.amountTo}
            onAmountRangeChange={updateAmount}
            onCodeCurrencyChange={updateCodeCurrency}
            selectedCodeCurrency={filters.codeCurrency}
          />
          <AreaSalesFilter
            icon={<Building2 className="h-4 w-4" />}
            onSelectionChange={(value: number | null) =>
              updateAreaSalesId(value === null ? null : value.toString())
            }
            placeholder="Seleccionar punto de venta..."
            selectedValue={
              filters.areaSalesId ? parseInt(filters.areaSalesId) : null
            }
            title="Puntos de venta"
          />

          <PaymentGatewayDropdown
            onPaymentGatewayChange={updatePaymentGatewayIds}
            selectedPaymentGateways={filters.paymentGatewayIds ?? []}
          />

          <AdvancedFilters />
        </div>

        {/* Resumen de filtros activos */}
        {hasActiveFilters && <SelectionSummary />}
      </div>
    </div>
  )
}
